export const HANKE_ATTACHMENTS_QUERY_KEY = 'hanke-attachments';
